module.exports = __webpack_public_path__ + "img/logo_text.2ea424cd.png";